import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SalesforceFormTypes, SalesforceWarehouseForm } from './SalesforceWarehouseForm';
import { postWarehouse } from '../../../store/actions/warehouses';

export function ConnectSalesforceForm() {
  const dispatch = useDispatch();
  const brandName = useSelector((state) => state.role.supplier.name);
  const submit = (connectionData) => {
    const warehouseToSubmit = {
      name: `${brandName} Salesforce`,
      orders_integration_type: 'salesforce_commerce_cloud',
      orders_integration_data: {
        connection_data: connectionData,
      },
    };
    dispatch(postWarehouse(warehouseToSubmit));
  };

  return <SalesforceWarehouseForm onSubmit={submit} formType={SalesforceFormTypes.ADD} />;
}
